export default __webpack_public_path__ + "static/media/hungree.7b56fb6a.svg";